module.exports = __webpack_public_path__ + "static/media/man.389fd76e.svg";